export default __webpack_public_path__ + "static/media/our_breakfast@3x.326ae585.png";